import type { ICategoryMM, ICategoryMMIcon, IPromoCategoryMM } from '../models/ICategoryMM';
import { Transliterate } from '~/shared/helpers';

export class CategoryMM {
  public title: string;
  public id: number;
  public icon: ICategoryMMIcon;
  public childrens?: CategoryMM[];
  public path?: number[];
  public image?: string;
  public parent?: CategoryMM;

  constructor(category: ICategoryMM) {
    this.title = category.title;
    this.id = category.id;
    this.icon = category.icon;
    this.childrens = category.childrens;
    this.path = category.path;
    this.image = category.image;
    this.parent = category.parent;
  }

  public get url(): string {
    const { title, id } = this;

    const prefix = '/category/' + Transliterate.transliterateTitle(title);
    return prefix + id;
  }
}

export class PromoCategoryMM extends CategoryMM {
  public deepLink: string;
  public subtitle: string;

  constructor(category: IPromoCategoryMM) {
    super(category);
    this.deepLink = category.deepLink;
    this.subtitle = category.subtitle;
  }

  public override get url(): string {
    return this.deepLink;
  }
}